// Outils partagés des tables de personnes (module People + hub CCR).
// Source unique : tri (cmpVal), recherche accent-insensible (normalizeName),
// définition d'« actif » (contrat couvrant la date du jour).

// Accent-insensitive lowercase ('Müller' → 'muller') pour la recherche par nom.
export function normalizeName(s) {
  return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
}

export function cmpVal(a, b) {
  if (a == null && b == null) return 0;
  if (a == null) return 1;   // nulls last
  if (b == null) return -1;
  // Numeric-first : capte les Decimal sérialisés en string ('98400.00' etc.)
  const na = Number(a);
  const nb = Number(b);
  if (a !== '' && b !== '' && !Number.isNaN(na) && !Number.isNaN(nb)) {
    if (na < nb) return -1;
    if (na > nb) return 1;
    return 0;
  }
  return String(a).localeCompare(String(b));
}

export function todayIso() {
  return new Date().toISOString().slice(0, 10);
}

// Un contrat est « en cours » s'il couvre la date du jour.
export function contractCoversToday(c, today = todayIso()) {
  return (c.start_date || '') <= today && (c.end_date == null || c.end_date >= today);
}

// Une personne est « active » si au moins un de ses contrats couvre la date du jour.
export function personIsActive(contracts, today = todayIso()) {
  return (contracts || []).some(c => contractCoversToday(c, today));
}

// Champ _search standard : prénom + nom + département + groupe (les absents sont ignorés).
export function buildSearchKey(...parts) {
  return normalizeName(parts.filter(Boolean).join(' '));
}
